/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 01/02/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import React from "react";

const PieChart = ({ data }) => {
  if (!data || data.length === 0) return null;

  // Paleta extendida a 10 colores vibrantes
  const colors = [
    "#4682B4", "#4CAF50", "#FF9800", "#E91E63", "#9C27B0",
    "#00BCD4", "#8BC34A", "#FFEB3B", "#795548", "#607D8B"
  ];

  const size = 220; // Un poco más grande para 10 valores
  const radius = 80;
  const innerRadius = 45; // Radio del hueco central (Dona)
  const center = size / 2;
  const total = data.reduce((sum, item) => sum + item.value, 0);

  let cumulativeAngle = 0;

  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "row", 
      alignItems: "center", 
      flexWrap: "wrap",
      gap: "20px",
      padding: "10px",
      backgroundColor: "#f9f9f9",
      borderRadius: "8px"
    }}>
      <div style={{ position: "relative", width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <g transform={`rotate(-90 ${center} ${center})`}>
            {data.map((item, index) => {
              const val = parseFloat(item.value) || 0;
              if (val <= 0) return null;

              const angle = (val / total) * 360;
              
              // Cálculo de coordenadas
              const x1 = center + radius * Math.cos((Math.PI * cumulativeAngle) / 180);
              const y1 = center + radius * Math.sin((Math.PI * cumulativeAngle) / 180);
              
              cumulativeAngle += angle;
              
              const x2 = center + radius * Math.cos((Math.PI * cumulativeAngle) / 180);
              const y2 = center + radius * Math.sin((Math.PI * cumulativeAngle) / 180);

              const largeArcFlag = angle > 180 ? 1 : 0;

              const pathData = `
                M ${center} ${center}
                L ${x1} ${y1}
                A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}
                Z
              `;

              return (
                <path
                  key={index}
                  d={pathData}
                  fill={colors[index % colors.length]}
                  stroke="#fff"
                  strokeWidth="2"
                />
              );
            })}
            {/* Círculo central para efecto Dona */}
            <circle cx={center} cy={center} r={innerRadius} fill="#f9f9f9" />
          </g>
        </svg>
        
        {/* Texto central con el Total */}
        <div style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          width: innerRadius * 2
        }}>
          <span style={{ fontSize: "10px", color: "#666", display: "block" }}>TOTAL</span>
          <strong style={{ fontSize: "14px" }}>${total.toLocaleString()}</strong>
        </div>
      </div>

      {/* Leyenda en dos columnas si hay muchos datos */}
      <div style={{ 
        display: "grid", 
        gridTemplateColumns: data.length > 5 ? "1fr 1fr" : "1fr", 
        gap: "8px 15px",
        fontFamily: "sans-serif", 
        fontSize: "11px" 
      }}>
        {data.map((item, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center" }}>
            <div style={{
              width: "10px", height: "10px", 
              backgroundColor: colors[index % colors.length],
              marginRight: "6px", borderRadius: "2px",
              flexShrink: 0
            }} />
            <span style={{ whiteSpace: "nowrap" }}>
              <span style={{ color: "#555" }}>{item.label}:</span> <strong>{((item.value / total) * 100).toFixed(1)}%</strong>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChart;